import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public isLogged = new Subject<any>();

  public authConfig: AuthConfig = {
    issuer: 'https://accounts.d4science.org/auth/realms/d4science',
    redirectUri: "https://it-ioos.eu",
    clientId: 'Itineris-Marine-Hub-Autentication',
    dummyClientSecret: "dl6IXDhLwQ2PYQ72MAIQaquzQUyanoDC",
    responseType: 'code',
    scope: 'openid profile email offline_access',
    showDebugInformation: true,
    sessionChecksEnabled: false,
    strictDiscoveryDocumentValidation: false,
  };

  constructor(private OAuth: OAuthService) {}

  public configureAuth() {
    this.OAuth.setStorage(sessionStorage);
    this.OAuth.configure(this.authConfig);
    this.OAuth.setupAutomaticSilentRefresh();
    this.OAuth.loadDiscoveryDocumentAndTryLogin().then(() => {
      if (this.OAuth.hasValidAccessToken()) {
        console.log('Login completato con successo!');
        this.isLogged.next(true)
      } else {
        console.warn('Login non completato o token non valido');
        this.isLogged.next(false)
      }
    });
  }

  public login() {
    this.OAuth.initLoginFlow();
  }

  public logout() {
    this.OAuth.logOut();
    this.OAuth.revokeTokenAndLogout();
  }
}


